import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
} from "axios";
import router from "@/router/index";

export class DataService {
  protected readonly instance: AxiosInstance;

  public constructor() {
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_URL,
    });
    // this._authInterceptor();
    this.instance.interceptors.request.use((request) =>
      this._handleRequest(request)
    );
  }

  private _successHandler = (response: AxiosResponse) => {
    console.log("Success Handler");
    return response;
  };

  private _errorHandler = (error: AxiosError) => {
    console.log("Error Handler");
    console.log({ errorHandlerError: error.response });
    const status = error.response?.status;

    if (status === 401) {
      console.log("unauthorized");
      router.push("/login");
    }

    if (status === 500) {
      console.log("Server Error");
    }

    if (status === 405) {
      console.log("Not Allowed");
    }

    return Promise.reject({ ...error });
  };

  private _authInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => this._successHandler(response),
      (error) => this._errorHandler(error),
    );
  };

  private _handleRequest = function (config: AxiosRequestConfig) {
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json";
    config.headers["Authorization"] = `Bearer ${localStorage.token}`;
    config.headers["Access-Control-Allow-Origin"] = "*";
    console.log({ reqHandle: "Request Handler", config: config });

    return config;
  };
}
